module.exports = __webpack_public_path__ + "static/img/performance02.22c9d272.jpg";